import React, { useEffect, useState } from 'react';
import api from '../services/api';
import type StudyParticipantModel from '../models/StudyParticipantModel';
import type StudyModel from '../models/StudyModel';
import type CycleAnswerModel from '../models/CycleAnswerModel';
import type DateAnswerModel from '../models/DateAnswerModel';
import Table from './Table';

type PropTypes = {
    study?: StudyModel;
    participant?: StudyParticipantModel;
};

const StudyAnswers = ({ study, participant }: PropTypes) => {
    const [cycleAnswers, setCycleAnswers] = useState<CycleAnswerModel[]>([]);
    const [cycleColumns, setCycleColumns] = useState<string[]>([]);
    const [dateAnswers, setDateAnswers] = useState<DateAnswerModel[]>([]);
    const [dateColumns, setDateColumns] = useState<string[]>([]);

    const pullCycleAnswers = async () => {
        const { answers, columns, success } = await api.getCycleAnswers(
            study?.id,
            participant?.id,
        );
        if (success) {
            setCycleAnswers(answers);
            setCycleColumns(columns);
        }
    };

    const pullDateAnswers = async () => {
        const { answers, columns, success } = await api.getDateAnswers(
            study?.id,
            participant?.id,
        );
        if (success) {
            setDateAnswers(answers);
            setDateColumns(columns);
        }
    };

    useEffect(() => {
        void pullCycleAnswers();
        void pullDateAnswers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="mt-4">
            <div className="flex items-center mb-4">
                <div className="text-primary text-3xl">Study Answers</div>
            </div>
            <Table
                key={`cycle-${cycleColumns.length}`}
                title="Cycle Answers"
                data={cycleAnswers}
                columns={cycleColumns}
            />
            <Table
                key={`date-${cycleColumns.length}`}
                title="Date Answers"
                data={dateAnswers}
                columns={dateColumns}
            />
        </div>
    );
};

export default StudyAnswers;
